import React from "react"
import styles from "./index.module.scss"
import ContentWithSidebars from "../../components/templates/ContentWithSidebars"
import AccountSettingsRightSidebar from "../../components/AccountSettingsRightSidebar"
import AccountSettingsContainer from "../../containers/AccountSettingsContainer"
import services from "../../services"
import Loading from "../../components/Loading/Loading"
import { toast } from "react-toastify"
import ToastInfo from "../../components/ToastContents/ToastInfo"

const AccountSettingsPage = () => {
  const [state, setState] = React.useState({ isLoading: false })

  React.useEffect(() => {
    setState({ isLoading: true })
    services.accountServices.getAccountSettings().then(({ data }) => {
      setState({
        data,
        isLoading: false,
      })
    })
  }, [])

  const setSettings = (data) =>
    new Promise((res, rej) =>
      services.accountServices
        .setAccountSettings(data)
        .then((response) => {
          // Response structure: { data: { message: "...", ... } } or { data: UserSerializer }
          const responseData = response?.data || response
          const message = responseData?.message
          
          // Check if this is a password change (both admin and non-admin)
          if (data.password) {
            // Show success message for password change
            const successMessage = message || 'Password update successful. Please check your email to confirm password changes.'
            toast.success(
              <ToastInfo>{successMessage}</ToastInfo>,
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              }
            )
            // Refresh settings to get updated data
            refreshSettings()
            res(responseData)
          } else {
            // For other settings updates (email, phone, etc.)
            setState({
              data: responseData,
              isLoading: false,
            })
            res(responseData)
          }
        })
        .catch((error) => {
          console.error("Settings update error:", error) // Debug log
          const errorData = error?.response?.data || error?.data || { error: "An error occurred" }
          rej(errorData)
        }),
    )

  const refreshSettings = () => {
    services.accountServices.getAccountSettings().then(({ data }) => {
      setState((prev) => ({
        ...prev,
        data,
        isLoading: false,
      }))
    })
  }

  return (
    <div className={styles.pageWrap}>
      <ContentWithSidebars>
        <div className={styles.settingsLayout}>
          <div className={styles.settingsContent}>
            {state.isLoading ? (
              <Loading />
            ) : (
              <>
                {state.data && (
                  <AccountSettingsContainer
                    data={state.data}
                    setSettings={setSettings}
                    refreshSettings={refreshSettings}
                  />
                )}
              </>
            )}
          </div>
          <div className={styles.settingsSidebar}>
            <AccountSettingsRightSidebar />
          </div>
        </div>
      </ContentWithSidebars>
    </div>
  )
}

export default AccountSettingsPage
